export const PART_UNIT_NAMES = [
    'UNITS',
    'METER',
    'SQUARE_METER',
    'CUBIC_METER',
    'KILOGRAM',
    'LITER',
    'BOX',
    'PACK',
    'BOTTLE',
    'ROLL'
];
